export default __webpack_public_path__ + "static/media/27-Birthday-celebration.3bd7b65a.jpeg";